import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { BigButton } from "@/components/Layout";

export const UsernameForm = () => {
  const { user, refreshUser, t } = useApp();
  const [name, setName] = useState(user.username || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.put("/auth/username", { username: name.trim() }); toast.success(t("Username saved")); await refreshUser(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3" data-testid="username-form">
      <Input value={name} onChange={(e) => setName(e.target.value)} placeholder={t("Choose a username")} autoCapitalize="none"
        className="h-14 rounded-2xl bg-white text-base" data-testid="settings-username-input" />
      <BigButton onClick={save} disabled={busy || name.trim() === (user.username || "")} data-testid="settings-save-username-btn">{busy ? t("Saving…") : t("Save username")}</BigButton>
    </div>
  );
};
